import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "page-content__inner" }
const _hoisted_2 = { class: "stats" }
const _hoisted_3 = { class: "stat" }
const _hoisted_4 = { class: "stat complete" }
const _hoisted_5 = { class: "stat inprogress" }
const _hoisted_6 = { class: "stat required" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranslatedText = _resolveComponent("TranslatedText")!
  const _component_MenuBar = _resolveComponent("MenuBar")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_UserProgressRow = _resolveComponent("UserProgressRow")!
  const _component_Table = _resolveComponent("Table")!
  const _component_Pagination = _resolveComponent("Pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.totalCandidatesCount), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_TranslatedText, { path: "reporting.progress.candidates" })
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.totalCompleteCount), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_TranslatedText, { path: "reporting.progress.complete" })
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.inProgressCount), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_TranslatedText, { path: "reporting.progress.in-progress" })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.overdueCount), 1),
        _createElementVNode("div", null, [
          _createVNode(_component_TranslatedText, { path: "reporting.progress.required" })
        ])
      ])
    ]),
    _createVNode(_component_MenuBar, {
      sortItems: _ctx.sortItems,
      sortColumn: _ctx.currentSortColumn,
      sortOrder: _ctx.currentSortOrder,
      searchText: _ctx.searchText,
      filters: _ctx.filterOptions,
      onSort: _ctx.handleSort,
      onUpdateSearch: _ctx.handleSearchChange,
      onUpdateFilter: _ctx.handleFilterChange,
      onApplyFilter: _ctx.handleFilterApply,
      onResetFilter: _ctx.handleFilterReset
    }, null, 8, ["sortItems", "sortColumn", "sortOrder", "searchText", "filters", "onSort", "onUpdateSearch", "onUpdateFilter", "onApplyFilter", "onResetFilter"]),
    _createVNode(_component_Table, {
      keyProp: "id",
      rows: _ctx.rowData,
      sortOrder: _ctx.currentSortOrder,
      sortColumn: _ctx.currentSortColumn
    }, {
      head: _withCtx(() => [
        _createElementVNode("tr", null, [
          _createElementVNode("th", _hoisted_7, [
            _createVNode(_component_Checkbox, {
              value: _ctx.selectedAll,
              text: "",
              onChange: _ctx.handleSelectAllChange
            }, null, 8, ["value", "onChange"])
          ]),
          _cache[0] || (_cache[0] = _createElementVNode("th", { class: "text-center" }, null, -1)),
          _createElementVNode("th", null, [
            _createVNode(_component_TranslatedText, { path: "form.first-name" })
          ]),
          _createElementVNode("th", null, [
            _createVNode(_component_TranslatedText, { path: "form.surname" })
          ]),
          _createElementVNode("th", _hoisted_8, [
            _createVNode(_component_TranslatedText, { path: "progress.viewed" })
          ]),
          _createElementVNode("th", _hoisted_9, [
            _createVNode(_component_TranslatedText, { path: "progress.title" })
          ])
        ])
      ]),
      default: _withCtx(({ row }) => [
        _createVNode(_component_UserProgressRow, {
          data: row,
          hotspotId: _ctx.currentHotspot?.id,
          selected: 
            _ctx.selectedIds.has(row.id) || (_ctx.selectedAll && !_ctx.excludedIds.has(row.id))
          ,
          onSelect: _ctx.handleItemSelectChange
        }, null, 8, ["data", "hotspotId", "selected", "onSelect"])
      ]),
      _: 1
    }, 8, ["rows", "sortOrder", "sortColumn"]),
    _createVNode(_component_Pagination, {
      currentPage: _ctx.paginationDetails?.pageNumber ?? 1,
      totalRows: _ctx.paginationDetails?.total ?? 0,
      onChangePage: _ctx.handleChangePage,
      onChangeRowCount: _ctx.handleChangeRowCount
    }, null, 8, ["currentPage", "totalRows", "onChangePage", "onChangeRowCount"])
  ]))
}